import { GET_INVOICE } from './getInvoice';
import { UPDATE_INVOICE } from './updateInvoice';
import { APPLY_CHARGES } from './applyCharges';

import { UPLOAD_INVOICE } from './upsertDocument';
import { DELETE_INVOICE_DOCUMENT } from './deleteDocument';
import { GET_INVOICE_DOCUMENT } from './getInvoiceDocument';

export const invoiceApi = {
  getByID: GET_INVOICE,
  update: UPDATE_INVOICE,
  applyCharges: APPLY_CHARGES,

  uploadInvoiceDocument: UPLOAD_INVOICE,
  getInvoiceDocument: GET_INVOICE_DOCUMENT,
  deleteInvoiceDocument: DELETE_INVOICE_DOCUMENT,
};
